import { i18n } from '../../main'

const options = {
  timeout: Infinity,
  maximumAge: 0,
  enableHighAccuracy: true
}

function getCoords () {
  if (navigator.geolocation) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(function (position) {
        resolve({
          latitude: position.coords.latitude.toFixed(6),
          longitude: position.coords.longitude.toFixed(6)
        })
      }, function (error) {
        let gpsError = ''
        switch (error.code) {
          case error.PERMISSION_DENIED:
            gpsError = i18n.t('error.gps.errorPermissionDenied')
            break
          case error.POSITION_UNAVAILABLE:
            gpsError = i18n.t('error.gps.errorPositionUnavailable')
            break
          case error.TIMEOUT:
            gpsError = i18n.t('error.gps.errorTimeout')
            break
          case error.UNKNOWN_ERROR:
            gpsError = i18n.t('error.gps.errorUnknown')
            break
        }
        reject(gpsError)
      }, options)
    })
  } else {
    return new Error('Geolocation is not supported by this browser.')
  }
}

export default getCoords
